import { render, staticRenderFns } from "./ListingDetail.vue?vue&type=template&id=0b81df83&scoped=true"
import script from "./ListingDetail.vue?vue&type=script&lang=js"
export * from "./ListingDetail.vue?vue&type=script&lang=js"
import style0 from "./ListingDetail.vue?vue&type=style&index=0&id=0b81df83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b81df83",
  null
  
)

export default component.exports